import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	projectsTitle: {
		id: 'horizontal-nav-header.breadcrumbs.project',
		defaultMessage: 'Projects',
		description: 'Title of the breadcrumb that navigates to the projects directory',
	},
});
